import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { MONTHS } from "@/lib/format";

const KWARTALEN = [
  { value: 1, label: "Q1 (jan-mrt)" },
  { value: 2, label: "Q2 (apr-jun)" },
  { value: 3, label: "Q3 (jul-sep)" },
  { value: 4, label: "Q4 (okt-dec)" },
];

export default function PeriodFilter({
  periode, jaar, maand, kwartaal, jaren, onChange,
}) {
  const set = (patch) => onChange({ periode, jaar, maand, kwartaal, ...patch });
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="period-filter">
      <div className="inline-flex rounded-md border border-slate-200 bg-white p-0.5">
        {[
          { v: "maand", l: "Maand" },
          { v: "kwartaal", l: "Kwartaal" },
          { v: "jaar", l: "Jaar" },
          { v: "ytd", l: "YTD" },
        ].map((p) => (
          <Button
            key={p.v}
            type="button"
            variant={periode === p.v ? "default" : "ghost"}
            size="sm"
            data-testid={`period-${p.v}-btn`}
            className={periode === p.v ? "bg-slate-900 text-white hover:bg-slate-800 h-8 px-3" : "h-8 px-3 text-slate-600"}
            onClick={() => set({ periode: p.v })}
          >
            {p.l}
          </Button>
        ))}
      </div>

      <Select value={String(jaar)} onValueChange={(v) => set({ jaar: parseInt(v) })}>
        <SelectTrigger className="w-28 h-9" data-testid="period-jaar-select">
          <SelectValue placeholder="Jaar" />
        </SelectTrigger>
        <SelectContent>
          {(jaren || []).map((y) => (
            <SelectItem key={y} value={String(y)}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>

      {periode === "maand" && (
        <Select value={String(maand)} onValueChange={(v) => set({ maand: parseInt(v) })}>
          <SelectTrigger className="w-36 h-9" data-testid="period-maand-select">
            <SelectValue placeholder="Maand" />
          </SelectTrigger>
          <SelectContent>
            {MONTHS.map((m, i) => (
              <SelectItem key={m} value={String(i + 1)}>{m}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      {periode === "kwartaal" && (
        <Select value={String(kwartaal)} onValueChange={(v) => set({ kwartaal: parseInt(v) })}>
          <SelectTrigger className="w-40 h-9" data-testid="period-kwartaal-select">
            <SelectValue placeholder="Kwartaal" />
          </SelectTrigger>
          <SelectContent>
            {KWARTALEN.map((q) => (
              <SelectItem key={q.value} value={String(q.value)}>{q.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
